import { BTable, BFormGroup, BFormInput, BFormCheckbox } from "bootstrap-vue";
import Loading from "@@/core/components/shared/Loading/Loading";
import { create } from "lodash";

export default {
  name: "SalesManagement",
  components: {
    Loading,
    BTable,
    BFormGroup,
    BFormInput,
    BFormCheckbox,
  },
  data() {
    return {
      sellers: [],
      counter: 1,
      intervalId: null,
    };
  },
  watch: {},
  mounted() {
    this.loadData();
    this.intervalId = setInterval(() => {
      this.loadData();

      // this.$refs.voice.play();
    }, 10000);
  },

  beforeDestroy() {
    clearInterval(this.intervalId);
  },
  computed: {
    interactionEnabled() {
      return this.$store.getters["admin/getInteractionEnabled"];
    },
  },
  methods: {
    enableSoundPlayback() {
      this.$store.commit("admin/setInteractionEnabled", true);
    },
    async loadData() {
      const response = await this.$axios(`admin/sellers-list-special`);
      this.sellers = response.data.data.sellers;
      const lastRequestِDate = new Date(
        response.data.data.last_request.created_at,
      );
      const nowDate = new Date(response.data.data.now);

      // اختلاف به ثانیه
      const diffInSeconds = (nowDate - lastRequestِDate) / 1000;

      if (diffInSeconds <= 10) {
        this.$refs.voice.play();
      } else {
        this.$refs.voice.pause();
      }
      console.log(diffInSeconds, "diffInSeconds");
    },
  },
};
